// extracted by mini-css-extract-plugin
export var fullWidthButton = "_od-0";